"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 16px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  color: ", ";\n\n  font-size: 14px;\n  font-weight: 600;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var common_1 = require("../common");

var StyledH5 = styled_components_1["default"].h5(_templateObject(), common_1.headingCommon, function (_ref) {
  var contrast = _ref.contrast,
      theme = _ref.theme;
  return contrast ? theme.palette.text.contrast : theme.palette.text["default"];
}, bitcoincom_pkg_theme_1.media.md(_templateObject2()));
/**
 * H5 component - Header 5 used for page headings
 *
 * @param props.children Child components
 * @param props.contrast Sets contrast mode
 */

var H5 = function H5(_a) {
  var children = _a.children,
      _a$contrast = _a.contrast,
      contrast = _a$contrast === void 0 ? false : _a$contrast,
      rest = __rest(_a, ["children", "contrast"]);

  return react_1["default"].createElement(StyledH5, Object.assign({
    contrast: contrast
  }, rest), children);
};

exports["default"] = H5;